import { ArrowUpRight } from 'lucide-react'
import { Bagian } from './Bagian'
import { PRODUK_SIAP, type Produk } from '../lib/data'

/**
 * Daftar produk sebagai baris buku besar, bukan kartu.
 *
 * Yang belum dibangun tetap mendapat barisnya — dengan tulisan "menyusul",
 * bukan tombol yang menuju 404 atau kartu yang berpura-pura bisa dibuka.
 */
export function BagianProduk({ produk }: { produk: Produk[] }) {
  return (
    <Bagian
      id="products"
      judul="One account, one plan, every platform"
      keterangan="Sign in once, and every platform opens with the same account and the same subscription. Connect accounts and post to each platform separately."
    >
      <ul className="border-t border-border">
        {produk.map((p) => {
          const siap = PRODUK_SIAP.has(p.code)

          return (
            <li
              key={p.code}
              className="grid items-center gap-x-6 gap-y-2 border-b border-border py-5 lg:grid-cols-12"
            >
              <h3 className="font-medium lg:col-span-3">{p.name}</h3>
              <p className="text-sm text-muted-foreground lg:col-span-6">{p.description}</p>
              <div className="lg:col-span-3 lg:text-right">
                {siap ? (
                  <a
                    href={p.origin}
                    className="inline-flex items-center gap-1.5 rounded-sm text-sm font-medium text-foreground underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                  >
                    Open {p.name}
                    <ArrowUpRight aria-hidden className="size-4 text-muted-foreground" />
                  </a>
                ) : (
                  <span className="inline-block rounded-full border border-border px-2.5 py-0.5 text-xs text-muted-foreground">
                    Coming soon
                  </span>
                )}
              </div>
            </li>
          )
        })}

        {produk.length === 0 && (
          <li className="border-b border-border py-5 text-sm text-muted-foreground">
            Loading catalog…
          </li>
        )}
      </ul>

      <p className="mt-4 max-w-2xl text-sm text-muted-foreground">
        Facebook and TikTok are also planned. Neither appears on this page until it can actually
        be used.
      </p>
    </Bagian>
  )
}
